module.exports = __webpack_public_path__ + "7cddc8baac876439cdc7b52bd2d310cc.svg";